import { type BookingForm } from "./bookingForm";
import { type BookingType } from "./bookingTypes";

// Keep in sync with VehicleBookingInSchema
type CreateUpdateBookingVehicleBooking = {
  id: string | null; // null to create
  registration: string;
  isPrimary: boolean | null;
};

// Keep in sync with BookingInSchema
export type CreateUpdateBookingRequestBody = {
  bookingRef: string;
  startDate: string;
  endDate: string;
  overrideArrivalStart: string | null;
  overrideArrivalEnd: string | null;
  overrideLateArrivalStart: string | null;
  overrideDepartureEnd: string | null;
  siteId: string;
  pitchType: string | null;
  pitchNumber: string | null;
  reservedPitch: string | null;
  bookingType: BookingType;
  note: string | null;
  balanceDue: number;
  autoBalance: boolean;
  zeroAndArriveUsed?: boolean;
  customer_id: string | null;
  vehicleBookings: Array<CreateUpdateBookingVehicleBooking>;
  pitchId: string | null;
};

export const parseBookingForm = (
  form: BookingForm,
): CreateUpdateBookingRequestBody => {
  const {
    primaryVehicleBooking,
    vehicleBookings,
    arrivalTimeStart,
    arrivalTimeEnd,
    lateArrivalTimeStart,
    departureTimeEnd,
    arrivalTimeStartEnabled,
    arrivalTimeEndEnabled,
    lateArrivalTimeStartEnabled,
    departureTimeEndEnabled,
    ...newForm
  } = form;

  return {
    ...newForm,
    customer_id: newForm.customer?.id ?? null,
    siteId: newForm.siteId ?? "",
    pitchType:
      newForm.bookingType === "experience_freedom"
        ? null
        : newForm.pitchType ?? "",
    reservedPitch:
      newForm.bookingType === "experience_freedom"
        ? null
        : newForm.reservedPitch ?? null,
    pitchId:
      newForm.bookingType === "experience_freedom" ? newForm.pitchId : null,
    overrideArrivalStart: arrivalTimeStartEnabled ? arrivalTimeStart : null,
    overrideArrivalEnd: arrivalTimeEndEnabled ? arrivalTimeEnd : null,
    overrideLateArrivalStart: lateArrivalTimeStartEnabled
      ? lateArrivalTimeStart
      : null,
    overrideDepartureEnd: departureTimeEndEnabled ? departureTimeEnd : null,
    vehicleBookings: [
      { ...primaryVehicleBooking, isPrimary: true },
      ...vehicleBookings.map((vehicleBooking) => ({
        ...vehicleBooking,
        isPrimary: false,
      })),
    ],
  };
};
